import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import LocalStorageMixin from 'react-localstorage';
import fillWithPlaceholders from 'utils/components/fillWithPlaceholders';
import Tooltip from 'components/Tooltip';
import Spinner, {SIZE_LARGE} from 'components/Spinner';
import {Request, GET, DELETE} from 'requests';
import RequestsMixin, {IS_DONE} from 'requests/RequestsMixin';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import IconCard from './IconCard';
import IconCardPlaceholder from './IconCardPlaceholder';
import IconSettings from './IconSettings';

const GRID_MINIMUM_ICONS_NEEDED = 16;
const GRID_ICON_MULTIPLES = 8;

const LIST_MINIMUM_ICONS_NEEDED = 10;
const LIST_ICON_MULTIPLES = 5;

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const IconsController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, LocalStorageMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      usingFocused: false,
      customFocused: false,
      showGridFocused: false,
      showListFocused: false,
      showIconsAsGrid: true,
      sortBy: 'updated_at',
      sortFunction: 'sortByRecentlyModified',
    };
  },

  componentWillMount() {
    this.setRequest({
      workingSetIcons: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });
  },

  getStateFilterKeys() {
    return ['showIconsAsGrid', 'sortBy', 'sortFunction'];
  },

  transitions(register) {
    register({
      request: this.requests.removeWorkingSetIcon,
      to: IS_DONE,
      call(rm) {
        this.setRequest({
          workingSetIcons: new Request({
            url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
            useCache: false,
          }),
        });
      },
    });
  },

  handleFocused() {
    this.setState({focused: !this.state.focused});
  },

  handleUsingFocused() {
    this.setState({usingFocused: !this.state.usingFocused});
  },

  handleCustomFocused() {
    this.setState({customFocused: !this.state.customFocused});
  },

  handleShowGridFocused() {
    this.setState({showGridFocused: !this.state.showGridFocused});
  },

  handleShowListFocused() {
    this.setState({showListFocused: !this.state.showListFocused});
  },

  handleRemovedIcon(workingSetIcon) {
    this.setRequest({
      removeWorkingSetIcon: new Request({
        method: DELETE,
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', workingSetIcon.id],
        record: workingSetIcon,
      }),
    });
  },

  handleShowAsGrid(event) {
    this.setState({showIconsAsGrid: true});
  },

  handleShowAsList(event) {
    this.setState({showIconsAsGrid: false});
  },

  handleSort(event) {
    switch (event.target.value) {
      case 'created_at':
        this.setState({sortBy: 'created_at', sortFunction: 'sortByRecentlyAdded'});
        break;
      case 'name':
        this.setState({sortBy: 'name', sortFunction: 'sortByName'});
        break;
      default:
        this.setState({sortBy: 'updated_at', sortFunction: 'sortByRecentlyModified'});
    }
  },

  resources() {
    const rm = this.resourceManager();

    return {
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
    };
  },

  sortByRecentlyAdded(workingSetIcons) {
    return workingSetIcons.sortBy(record => record.createdAt.unix()).reverse();
  },

  sortByRecentlyModified(workingSetIcons) {
    return workingSetIcons.sortBy(record => record.updatedAt.unix()).reverse();
  },

  sortByName(workingSetIcons) {
    return workingSetIcons.sortBy(record => record.name);
  },

  renderUsingLabel() {
    const {workingSetIcons, subscription} = this.resources();

    const iconsPerKitAllowed = subscription.iconsPerKitAllowed;
    const iconsAllowed = (iconsPerKitAllowed === Infinity) ? <span>&infin;</span> : iconsPerKitAllowed;
    let popover = null;

    if (this.state.usingFocused) {
      popover = (
        <Tooltip
          noIcon={true}
          content={<span>Using {workingSetIcons.size} of {iconsAllowed} icons per kit<br />available in your plan</span>}
        />
      );
    }

    return (
      <span className="use-count" onMouseOver={this.handleUsingFocused} onMouseOut={this.handleUsingFocused}>
        {popover}
        Using {workingSetIcons.size} of {iconsAllowed} available
      </span>
    );
  },

  renderSortOptions() {
    const {sortBy} = this.state;

    return (
      <div className="inline-block valign-middle m-xs-l-lg kit-display-option">
        <div className="form-group m-xs-b-0">
          <label htmlFor="kit-icons-sort" className="sr-only">Sort Icons by:</label>
          <select className="c-select br-a text-sm text text-muted" id="kit-icons-sort" value={sortBy} onChange={this.handleSort}>
            <option value="updated_at">Recently Modified</option>
            <option value="created_at">Recently Added</option>
            <option value="name">A &mdash; Z</option>
          </select>
        </div>
      </div>
    );
  },

  renderViewOptions() {
    const {showIconsAsGrid, showGridFocused, showListFocused} = this.state;
    const gridActive = (showIconsAsGrid) ? 'active' : '';
    const listActive = (showIconsAsGrid) ? '' : 'active';
    const gridPopover = (showGridFocused) ? <Tooltip noIcon={true} content="Grid view" /> : null;
    const listPopover = (showListFocused) ? <Tooltip noIcon={true} content="List view" /> : null;

    return (
      <div className="inline-block valign-middle text-xs-right kit-display-option">
        <div className="form-group m-xs-b-0">
          <label
            className={`radio-inline m-xs-a-0 m-xs-r-md p-xs-a-0 view-option ${gridActive}`}
            onClick={this.handleShowAsGrid}
            onMouseOver={this.handleShowGridFocused}
            onMouseOut={this.handleShowGridFocused}
          >
            {gridPopover}
            <i className={`ficon ficon-th ${gridActive}`} title="View icons as grid"></i>
          </label>
          <label
            className={`radio-inline m-xs-a-0 p-xs-a-0 view-option ${listActive}`}
            onClick={this.handleShowAsList}
            onMouseOver={this.handleShowListFocused}
            onMouseOut={this.handleShowListFocused}
          >
            {listPopover}
            <i className={`ficon ficon-th-list ${listActive}`} title="View icons as list"></i>
          </label>
        </div>
      </div>
    );
  },

  renderCustomLabel() {
    const {workingSetIcons, subscription} = this.resources();
    const customCount = workingSetIcons.filter(workingSetIcon => workingSetIcon.custom).size;
    const customAllowed = (subscription.customIconsAllowed === Infinity) ? '&infin;' : subscription.customIconsAllowed;

    let popover = null;

    if (this.state.customFocused) {
      popover = (
        <Tooltip
          noIcon={true}
          content={`Using ${customCount} of ${customAllowed} uploaded icons<br>available in your plan`}
        />
      );
    }

    return (
      <span className="use-count-uploaded" onMouseOver={this.handleCustomFocused} onMouseOut={this.handleCustomFocused}>
        {popover}
        <i className="ficon ficon-uploaded"></i> {customCount}
      </span>
    );
  },

  renderFailureAlert() {
    const {workingSetIcons} = this.resources();
    const failedWorkingSetIcons = workingSetIcons.filter((workingSetIcon) => {
      return workingSetIcon.status === 'errored';
    });

    let value = null;

    if (!failedWorkingSetIcons.isEmpty()) {
      value = (
        <div className="alert alert-danger bg-body m-xs-b-lg">
          <strong>Upload your icons we could not.</strong> Please try again or <a href="mailto:help@fortawesome.com" className="danger">let us know</a> if you continue to have trouble.
        </div>
      );
    }

    return value;
  },

  renderIcons() {
    const {kitToken} = this.props;
    const {showIconsAsGrid, sortFunction} = this.state;
    const {workingSetIcons} = this.resources();

    const sortedWorkingSetIcons = this[sortFunction](workingSetIcons.filter(record => !record.logo));
    const cardElements = sortedWorkingSetIcons
      .map((workingSetIcon, index) => {
        return (
          <IconCard
            key={workingSetIcon.id}
            kitToken={kitToken}
            workingSetIcon={workingSetIcon}
            onRemoveIcon={this.handleRemovedIcon}
            showInList={!showIconsAsGrid}
          />
        );
      })
      .push(<IconCardPlaceholder key="first-placeholder" kitToken={kitToken} />);

    const elements = fillWithPlaceholders(cardElements, {
      placeholder: IconCardPlaceholder,
      multipleOf: (showIconsAsGrid) ? GRID_ICON_MULTIPLES : LIST_ICON_MULTIPLES,
      minimum: (showIconsAsGrid) ? GRID_MINIMUM_ICONS_NEEDED : LIST_MINIMUM_ICONS_NEEDED,
      props: {kitToken},
    });

    const spacingClass = (showIconsAsGrid) ? 'grid-assets-xs-8' : 'grid-assets-xs-5';
    const layoutClass = (showIconsAsGrid) ? 'kit-assets-grid animated fadeIn' : 'kit-assets-list animated fadeIn';

    return (
      <div className={`grid-assets ${spacingClass} kit-assets kit-assets-named ${layoutClass} kit-assets-icons`}>
        {elements}
      </div>
    );
  },

  renderCluestick() {
    const {kitToken} = this.props;

    return (
      <div className="layout-center-center well bg-info bg-img bg-img-icons p-xs-a-xl m-xs-y-md text-xs-center" role="alert">
        <div className="ficon-4x text-muted m-xs-b-md">
          <i className="ficon ficon-captain-america ficon-fw"></i>
          <i className="ficon ficon-hawkeye ficon-fw"></i>
          <i className="ficon ficon-thor ficon-fw"></i>
          <i className="ficon ficon-ironman ficon-fw"></i>
          <i className="ficon ficon-upload-icon ficon-fw"></i>
        </div>
        <h2 className="text-2x m-xs-b-md font-weight-semibold">Assemble the perfect icon set for your site!</h2>

        <p className="lead text-muted m-xs-b-0">
          <Link to={`/kits/${kitToken}/icons/new`} className="text-white">Choose</Link> from our awesome icon sets
          and <Link to={`/kits/${kitToken}/icons/upload`} className="text-white">upload your own</Link>.<br />
          We’ll turn them into an icon font that’s speedy, bulletproof, and super-simple-to-use (just like Font Awesome).
        </p>
      </div>
    );
  },

  renderMain() {
    const {workingSetIcons} = this.resources();

    let cluestick = null;

    if (workingSetIcons.size === 0) {
      cluestick = this.renderCluestick();
    }

    return (
      <div>
        <div className="text-muted m-xs-b-md gg">
          <div className="gg-row">
            <div className="gg-col">
              {this.renderUsingLabel()} &middot; {this.renderCustomLabel()} &middot; <a href="/upgrade">Get More</a>
            </div>
            <div className="gg-col text-xs-right p-xs-l-md">
              {this.renderViewOptions()}
              {this.renderSortOptions()}
            </div>
          </div>
        </div>
        {cluestick}
        {this.renderFailureAlert()}
        {this.renderIcons()}
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-icons m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    const {
      kitToken,
    } = this.props;
    const mainRequests = [this.requests.workingSetIcons, this.requests.subscription];
    const {workingSetIcons} = this.resources();

    let addLabel = null;

    if (workingSetIcons.size > 0) {
      addLabel = 'Add';
    } else {
      addLabel = 'Add your first ICON';
    }

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <div>
          <div className="kit-asset-summary">
            <div className="kit-asset-header gg gg-bottom">
              <h3 className="kit-asset-title gg-col">
                Icons
                &thinsp;<IconSettings kitToken={kitToken} />
              </h3>
              <div className="kit-asset-actions gg-col text-xs-right text-muted">
                <Link to={`/kits/${kitToken}/icons/new`} className="link-dashed-none m-xs-r-md">
                  <i className="ficon ficon-plus-circle m-xs-r-xs"></i>{addLabel}
                </Link>
                <Link to={`/kits/${kitToken}/icons/upload`} className="link-dashed-none">
                  <i className="ficon ficon-uploaded m-xs-r-xs"></i>Upload
                </Link>
              </div>
            </div>
            <hr className="m-xs-y-sm" />
            <Requesting any={mainRequests} render={this.renderSpinner} />
            <Done all={mainRequests} render={this.renderMain} />
          </div>
        </div>
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(IconsController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconsController.js